import React from 'react'

import Decklist from 'components/decklists/DeckListWithMetaData'

export const WinnerOne: React.FC = () => {
  return (
    <Decklist
      name="Vertex Morning Trophy"
      drafter="Anonymized"
      description={
        <>
          Here&rsquo;s how the pros do it. Honestly this looks just as janky as
          mine.
        </>
      }
      maindeck={[
        [
          { name: 'Lantern-Lit Graveyard', set: 'CHK' },
          { name: 'Glimmerpost', set: 'SOM' },
          { name: 'Swamp', set: 'TSP' },
          { name: 'Forest', set: 'TSP' },
          { name: 'Slippery Karst', set: 'C13' },
          { name: 'Mountain', set: 'TSP' },
          { name: 'Tendo Ice Bridge', set: 'BOK' },
          { name: 'Llanowar Wastes', set: '10E' },
          { name: 'Piranha Marsh', set: 'ZEN' },
          { name: 'Terramorphic Expanse', set: '10E' },
          { name: 'Dakmor Salvage', set: 'FUT' },
          { name: 'Forest', set: 'TSP' },
          { name: 'Khalni Garden', set: 'WWK' },
          { name: 'Snow-Covered Forest', set: 'CSP' },
          { name: 'Vivid Grove', set: 'LRW' },
          { name: 'Cloudpost', set: 'MRD' },
          { name: 'Forest', set: 'M11' },
        ],
        [
          { name: 'Elves of Deep Shadow', set: 'RAV' },
          { name: 'Lotus Petal', set: 'MB2' },
          { name: 'Flame Jab', set: 'EVE' },
          { name: 'Boreal Druid', set: 'CSP' },
        ],
        [
          { name: 'Utopia Vow', set: 'PLC' },
          { name: 'Kavu Predator', set: 'PLC' },
          { name: "Tsabo's Web" },
        ],
        [
          { name: "Specter's Shroud" },
          { name: 'Fleshbag Marauder', set: 'ALA' },
          { name: 'Shambling Shell', set: 'RAV' },
          { name: "Kodama's Reach", set: 'CHK' },
          { name: 'Strangling Soot', set: 'TSP' },
          { name: 'Coalition Relic', set: 'FUT' },
        ],
        [
          { name: 'Mold Shambler', set: 'ZEN' },
          { name: 'Order of Yawgmoth' },
          { name: 'Disciple of Tevesh Szat' },
        ],
        [
          { name: 'Evil Eye of Urborg', set: 'TSP' },
          { name: 'Shriekmaw', set: 'LRW' },
          { name: 'Battle of Wits' },
          { name: 'Malakir Bloodwitch', set: 'ZEN' },
        ],
        [
          { name: 'Duplicant', set: 'MRD' },
          { name: "Sekki, Season's Guide" },
          { name: 'Argentum Armor', set: 'GN3' },
          { name: 'Seasons Past', set: 'SOI' },
          { name: 'Fiery Fall', set: 'CON' },
        ],
      ]}
    />
  )
}
